<template>
  <v-card class="main-card">
    <v-card-title class="screen-title mb-3">
      <span>各種ダウンロード</span>
    </v-card-title>
    <v-card-text class="pa-5" v-if="isLoaded">
      <div v-if="download.items.length > 0">
        <app-table
          primary-key="downloadSeq"
          :fields="download.fields"
          :items="download.items"
          :hover="true"
          :per-page="-1"
          @click:row="downloadFile"
          sticky-header="50vh"
        >
        </app-table>
      </div>
      <div v-else class="ml-3">現在ダウンロード情報はありません。</div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { FileInfo } from "@/apis/InformationApi";
import type { AppTableHeader } from "@/components/AppTable.vue";
import ApiNotFoundModal from "@/modals/error/ApiNotFoundModal.vue";

export default defineComponent({
  name: "DownloadList",
  data() {
    return {
      // 各種ダウンロード
      download: {
        fields: [
          { key: "fileName", title: "ファイル名", width: "200px" },
          { key: "downloadTitle", title: "説明", width: "200px" },
        ] as AppTableHeader<FileInfo>[],
        items: [] as FileInfo[],
      },
      isLoaded: false,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** 読み込み */
    async load() {
      this.download.items = await this.$api.information.getDownloadList();
    },
    /** 各種ファイルダウンロード */
    async downloadFile(entity: FileInfo) {
      /** ダウンロードする前にダウンロード対象のデータが存在するかの確認 */
      const fileCheckItem: boolean = (
        await this.$api.information.getDownloadList()
      ).some((e: FileInfo) => e.downloadSeq === entity.downloadSeq);
      if (fileCheckItem) {
        window.open(
          this.$api.information.getInformationDownloadUrl(entity.downloadSeq),
          "_blank"
        );
      } else {
        await this.$modal.show(ApiNotFoundModal);
      }
    },
  },
});
</script>
